import React from "react";
// import section heading
import SectionHeading from "../Common/SectionHeading";
// import tour guide data
import { TeamData } from "./PartnersSlideData";
// import Tour Guide Card
import TeamCard from "./PartnersSlideCard";
//  OwlCarousel Slider Import
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const PartnersSlide = () => {
  let responsive = {
    0: {
      items: 2,
    },
    600: {
      items: 3,
    },
    960: {
      items: 4,
    },
    1200: {
      items: 5,
    },
  };

  return (
    <section id="tour_guides_area" className="section_paddingx" >
      <div className="container">
        {/* <SectionHeading heading="Board of Directors" /> */}
        <div className="row">
          <div className="col-lg-12">
            <div className="guide_heading_area">
              <h3>Our Partners</h3>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="tour_guides_slider dot_style">
              <OwlCarousel
                className="owl-theme"
                responsive={responsive}
                autoplay={false}
                autoplayHoverPause={true}
                autoplayTimeout={2500}
                loop={true}
                margin={30}
                nav={false}
                dots={true}
              >
                {TeamData.map((data, index) => (
                  <TeamCard
                    img={data.img}
                    des={data.des}
                    name={data.name}
                    key={index}
                  />
                ))}
              </OwlCarousel>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSlide;
